<template>
    <textarea type="text" :value="value" @input="updateSelf($event.target.value)" />
</template>

<script>
    export default {
        props: ['value'],
        methods: {
            updateSelf (newValue) {
                this.$emit('input', newValue)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// TextAreaComponent.vue?495df486